import { OrderStatus as ShopifyOrderStatus } from "@repo/shopify/src/utils/order";

export enum DrawStatus {
  Online = "online",
  Offline = "offline",
  Lose = "lose",
}

export enum LoadingType {
  Fill = "fill",
  Screen = "screen",
  Content = "content",
}

export enum IconName {
  Apple = "Apple",
  AppleMusic = "AppleMusic",
  Check_100 = "Check_100",
  Close_100 = "Close_100",
  Close_100_small = "Close_100_small",
  Close_700 = "Close_700",
  Default_700 = "Default_700",
  Discount_700 = "Discount_700",
  Discount_grey = "Discount_grey",
  DownArrow_100 = "DownArrow_100",
  Edit_100 = "Edit_100",
  Google = "Google",
  Instagram = "Instagram",
  Kakao = "Kakao",
  Kakaotalk = "Kakaotalk",
  LeftArrow_100 = "LeftArrow_100",
  LeftArrow_700 = "LeftArrow_700",
  Line_long = "Line_long",
  Line_short = "Line_short",
  Menu_700 = "Menu_700",
  Minus_100 = "Minus_100",
  More_100 = "More_100",
  Naver = "Naver",
  Person_700 = "Person_700",
  Plus_100 = "Plus_100",
  Plus_100_small = "Plus_100_small",
  Plus_700 = "Plus_700",
  Pay_100 = "Pay_100",
  Qm_100 = "Qm_100",
  Information_100 = "Information_100",
  Return_100 = "Return_100",
  RightArrow_100 = "RightArrow_100",
  Search_100 = "Search_100",
  Search_700 = "Search_700",
  Share_700 = "Share_700",
  ShoppingBag_700 = "ShoppingBag_700",
  Sort_100 = "Sort_100",
  Spotify = "Spotify",
  Star_700 = "Star_700",
  Trash_100 = "Trash_100",
  Toast_error = "Toast_error",
  Toast_info = "Toast_info",
  Toast_success = "Toast_success",
  Toast_warning = "Toast_warning",
  Youtube = "Youtube",
  Email_100 = "Email_100",
  Loading = "Loading",
  Spinner = "Spinner",
  Lock = "Lock",
  Picture = "Picture",
}

// fulfillmentStatus
export enum OrderStatus {
  Pending = "PENDING", // 미결제
  Refunded = "REFUNDED", // 환불 완료
  Paid = "PAID", // 결제 완료
  Partially = "PARTIALLY_REFUNDED", // 일부 환불 or CS팀에서 취소 처리
  Fulfilled = "FULFILLED",
  Partially_Fulfilled = "PARTIALLY_FULFILLED",
  Unfulfilled = "UNFULFILLED",
  OnHold = "ON_HOLD",
}

export enum OrderStatusText {
  Refunded = "환불 완료",
  Canceled = "주문 취소",
  Partially = "부분 환불됨",
  Completed = "주문 완료",
  Partially_Completed = "부분 주문 완료",
  Returned = "반품 접수됨",
  Shipment = "발송 완료",
  Partially_Shipment = "부분 발송 완료",
  Preparing = "배송 준비 중",
  PrizeCancel = "당첨 취소",
  DrawCancel = "응모 취소",
  DrawLose = "미당첨",
  DrawWin = "당첨 🎉",
  DrawApply = "응모 완료",
}

export enum StatusColor {
  Error = "text-status-error",
  Processing = "text-status-processing",
  Finished = "text-status-finished",
  Pending = "text-status-pending",
}

export enum CancelReason {
  Customer = "CUSTOMER",
  Other = "OTHER",
}

export enum ReturnStatus {
  Requested = "requested",
  Approved = "approved",
}

export enum ErrorCode {
  UnidentifiedCustomer = "UNIDENTIFIED_CUSTOMER",
  InvalidCredentials = "INVALID_CREDENTIALS",
  Taken = "TAKEN",
  TooShort = "TOO_SHORT",
}

export enum ReturnStep {
  Request = "request",
  Requested = "requested",
}
